import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';

@Injectable()
export class CoverIndexService {
  public configUrl: string;
  public PythonURL: string;
  public ApiCoreURL: string;
  private loggedInUserId: number;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.loggedInUserId = + localStorage.getItem('loggedInUserId');
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'coverindex';
      this.ApiCoreURL = data.WebEndPoint2;
      this.PythonURL = data.PythonURL;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }

  public updateCoverIndex(engagementId: number, engBody: any) {
    return this.http.get(`${this.PythonURL}mapping/${engagementId}`);
    // .catch(this.handleError);
  }

  public downloadDatabookFromBlob(engagementId: number) {
    return this.http.get(`${this.ApiCoreURL}DataBook/DownloadDatabookFromBlob/${engagementId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public downloadPowerPivotDatabookFromBlob(engagementId: number) {
    return this.http.get(`${this.ApiCoreURL}DataBook/DownloadPowerPivotDatabookFromBlob/${engagementId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getDatabookstatus(engagementId: number, isDynamicDatabook: boolean) {
    return this.http.get(`${this.ApiCoreURL}DataBook/GetDatabookstatus/${engagementId}/${isDynamicDatabook}`);
  }

  public updateDatabookDataTab(engagementId: number) {
    return this.http.get(`${this.PythonURL}updataDatabookDataTab/${engagementId}`);
    // .catch(this.handleError);
  }

  public GenerateDatabookToQueue(engId: number, version: number, generateTemplate: boolean) {
    return this.http.post(`${this.ApiCoreURL}DataBook/CreateDatabookToQueue/${engId}/${version}/${generateTemplate}`, {});
  }

  public CheckDatabookStatus(EngId: number) {

    return this.http.get(`${this.ApiCoreURL}DataBook/CheckDatabookStatus/${EngId}`);
    // .catch(this.handleError);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
